/* Zero-price gifts. Theme guards are UX, not server authorization.
   Direct cart permalinks and checkout discounts require ERP/order review. */
(() => {
  'use strict';
  if (window.__jadoreGiftLines) return;
  window.__jadoreGiftLines = true;
  const el = document.querySelector('[data-jg-config]');
  if (!el) return;
  const boot = JSON.parse(el.textContent), policy = window.JadoreGiftPolicy;
  if (!boot.enabled || !policy) return;
  const root = String(boot.root || '/').replace(/\/?$/, '/');
  const nativeFetch = window.fetch.bind(window);
  let tail = Promise.resolve(), current = null, external = 0, busy = 0, timer, verified = false;
  let stateUnavailable = false, checkingOut = false;
  const rate = () => Number(window.Shopify?.currency?.rate);
  // Locale list from scripts/shopify-theme/umiedzynarodow-motyw.py (+ PL).
  const messages = {
    pl: 'Nie udało się potwierdzić prezentu. Spróbuj ponownie w koszyku.',
    en: 'Your gift could not be confirmed. Please try again in your bag.',
    de: 'Dein Geschenk konnte nicht bestätigt werden. Bitte versuche es im Warenkorb erneut.',
    es: 'No se ha podido confirmar tu regalo. Inténtalo de nuevo en el carrito.',
    fr: 'Votre cadeau n’a pas pu être confirmé. Réessayez dans votre panier.',
    it: 'Non è stato possibile confermare il regalo. Riprova nel carrello.',
    nl: 'Je cadeau kon niet worden bevestigd. Probeer het opnieuw in je winkelwagen.',
    'pt-PT': 'Não foi possível confirmar o seu presente. Tente novamente no carrinho.',
    sv: 'Din gåva kunde inte bekräftas. Försök igen i varukorgen.',
    nb: 'Gaven din kunne ikke bekreftes. Prøv igjen i handlekurven.',
    el: 'Δεν ήταν δυνατή η επιβεβαίωση του δώρου σας. Δοκιμάστε ξανά στο καλάθι.',
    ru: 'Не удалось подтвердить подарок. Попробуйте ещё раз в корзине.',
    uk: 'Не вдалося підтвердити подарунок. Спробуйте ще раз у кошику.'
  };
  const message = () => messages[boot.locale] || messages[boot.locale?.split('-')[0]] || messages.en;
  function error() {
    verified = false; paint();
    let node = document.querySelector('[data-jg-error]');
    if (!node) {
      node = document.createElement('p'); node.dataset.jgError = ''; node.setAttribute('role', 'alert');
      (document.querySelector('.jg-panel') || document.querySelector('[data-jk-slot="prezenty"]') || document.body).appendChild(node);
    }
    node.textContent = message();
  }
  let lastRequest = 0;
  async function request(path, body) {
    await new Promise(resolve => setTimeout(resolve, Math.max(0, 2100 - (Date.now() - lastRequest))));
    lastRequest = Date.now();
    const options = { credentials: 'same-origin', cache: 'no-store', headers: { Accept: body ? 'application/json' : 'text/html', 'X-JK': '1' } };
    if (body) { options.method = 'POST'; options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(body); }
    const ac = new AbortController(); options.signal = ac.signal;
    const timeout = setTimeout(() => ac.abort(), 8000);
    try {
      const response = await nativeFetch(root + path, options);
      if (!response.ok) throw new Error('Gift request failed');
      return body ? response : await response.text();
    } finally { clearTimeout(timeout); }
  }
  async function readOnce() {
    const text = await request('cart?section_id=jadore-gift-state');
    const doc = new DOMParser().parseFromString(text, 'text/html');
    const data = doc.querySelector('[data-jg-state]');
    if (!data) throw new Error('Missing gift state');
    const snapshot = JSON.parse(data.textContent);
    // Liquid cart JSON uses a currency string; keep the guard explicit.
    if (!snapshot.cart || !Array.isArray(snapshot.cart.items) || !snapshot.config) throw new Error('Invalid state');
    stateUnavailable = false;
    current = snapshot;
    return snapshot;
  }
  async function read() {
    // One retry for transport, malformed JSON or missing section; checkout fails open.
    for (let attempt = 0; attempt < 2; attempt++) {
      try { return await readOnce(); }
      catch (e) { if (attempt === 1) { stateUnavailable = true; throw e; } }
    }
  }
  function plan(s) { return policy.plan(s.cart, s.meta, s.config, rate()); }
  const marked = item => !!item.properties?._jp_gift;
  function needsCheckoutCorrection() {
    if (stateUnavailable || !current || !current.cart.items.some(marked)) return false;
    const p = plan(current);
    return !p.paidCount || current.cart.items.some(item => marked(item) && Object.hasOwn(p.updates, item.key)) ||
      Object.keys(p.changedAttributes).length > 0;
  }
  async function reconcile() {
    let touched = false;
    // Bound retries. Read again after every write; key hashes can change.
    for (let pass = 0; pass < 50; pass++) {
      const s = await read(), p = plan(s);
      const corrections = Object.entries(p.updates);
      if (corrections.length) {
        const [id, quantity] = corrections[0];
        await request('cart/change.js', { id, quantity }); touched = true; continue;
      }
      if (Object.keys(p.changedAttributes).length) {
        await request('cart/update.js', { attributes: p.changedAttributes }); touched = true; continue;
      }
      document.querySelectorAll('[data-jg-error]').forEach(node => node.remove());
      verified = true;
      return { s, p, touched };
    }
    throw new Error('Gift state did not converge');
  }
  function paint() {
    // Checkout stays usable without JS and during endpoint failure. Only the submit
    // listener delays a known marked gift that actually needs correction.
    if (!current) return;
    const p = plan(current);
    const money = value => new Intl.NumberFormat(boot.locale || 'pl', { style: 'currency', currency: 'PLN', maximumFractionDigits: value % 100 ? 2 : 0 }).format(value / 100);
    const missing = tier => Math.max(0, Number(tier === '600' ? current.config.prog1 : current.config.prog2) - p.p);
    document.querySelectorAll('[data-jg-tier]').forEach(tier => {
      const id = tier.dataset.jgTier, ready = !!p.allowed[id], status = tier.querySelector('[data-jg-status]');
      tier.classList.toggle('jg-tier--locked', !ready);
      tier.classList.toggle('jg-tier--ready', ready);
      if (status) status.textContent = p.selected[id] ? status.dataset.jgAdded : ready ? status.dataset.jgReady : `${status.dataset.jgMissing} ${money(missing(id))}`;
      const track = tier.querySelector('[role="progressbar"]');
      const progress = Math.min(100, Math.max(0, p.p / (id === '600' ? current.config.prog1 : current.config.prog2) * 100));
      if (track) { track.setAttribute('aria-valuenow', String(Math.round(progress))); track.firstElementChild.style.width = `${progress}%`; }
    });
    document.querySelectorAll('.jk-kafel').forEach(tile => {
      const c = current.config.catalog.find(c => c.tier === tile.dataset.jkWybor && (String(c.id) === tile.dataset.jgVariant || c.name === tile.dataset.jkWartosc));
      const allowed = c && c.available && c.price === 0 && p.allowed[c.tier];
      tile.disabled = busy > 0 || !allowed;
      tile.setAttribute('aria-disabled', String(tile.disabled));
      if (!tile.disabled) tile.removeAttribute('tabindex');
      tile.setAttribute('aria-pressed', String(!!c && p.selected[c.tier]?.id === c.id));
      const name = tile.querySelector('.jg-card__name'), choose = tile.querySelector('.jg-card__choose');
      if (c && name && name.textContent !== c.name) name.textContent = c.name;
      if (c && choose) choose.textContent = p.allowed[c.tier] ? choose.dataset.jgChoose : `${choose.dataset.jgMissing} ${money(missing(c.tier))}`;
      if (c?.image) {
        const frame = tile.querySelector('.jk-kafel__foto');
        if (frame && !frame.querySelector('img[data-jg-photo]')) {
          const img = document.createElement('img'); img.dataset.jgPhoto = ''; img.src = c.image;
          img.alt = c.name; img.width = img.height = 360; img.loading = 'lazy';
          frame.querySelector('.jg-board')?.remove(); frame.querySelector('.jk-zast')?.remove(); frame.querySelector('img')?.remove(); frame.prepend(img);
          frame.classList.add('jk-kafel__foto--img');
        }
      }
    });
    for (const [name, value] of Object.entries(p.attributes)) {
      document.querySelectorAll('[data-jk-attr]').forEach(i => { if (i.dataset.jkAttr === name) i.value = value; });
    }
  }
  function enqueue(job) {
    verified = false; busy++; paint();
    const run = tail.then(async () => { try { return await job(); } catch (e) { throw e; } });
    tail = run.catch(() => {}).finally(() => { busy--; paint(); });
    return run;
  }
  async function select(tier, name) {
    const before = await reconcile(), c = before.s.config.catalog.find(c => c.tier === tier && (String(c.id) === name || c.name === name));
    if (!c || !before.p.allowed[tier] || !c.available || c.price !== 0) throw new Error('Gift unavailable');
    const deselect = before.p.selected[tier]?.id === c.id;
    // Remove all lines of this tier, even split properties/duplicate variants.
    for (let pass = 0; pass < 10; pass++) {
      const s = await read();
      const item = s.cart.items.find(i => s.config.catalog.some(x => x.tier === tier && String(x.id) === String(i.variant_id)));
      if (!item) break;
      await request('cart/change.js', { id: item.key, quantity: 0 });
      if (pass === 9) throw new Error('Too many gift lines');
    }
    if (!deselect) {
      const s = await read();
      if (!plan(s).allowed[tier]) throw new Error('Threshold changed');
      await request('cart/add.js', { items: [{ id: c.id, quantity: 1, properties: { _jp_gift: tier } }] });
    }
    const after = await reconcile();
    if (!deselect && after.p.selected[tier]?.id !== c.id) throw new Error('Gift not added');
    // Full render updates pictures, quantities, sum and drawer together. No optimistic success.
    location.reload();
  }
  const schedule = () => { verified = false; paint(); clearTimeout(timer); timer = setTimeout(() => {
    enqueue(async () => { const r = await reconcile(); paint(); if (r.touched) location.reload(); }).catch(error);
  }, 150); };
  // Observe successful cart mutations (including theme/product forms). Own requests use captured fetch.
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : input?.url || '';
    const mutation = /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url) &&
      String(init?.method || input?.method || 'GET').toUpperCase() === 'POST';
    if (mutation) { external++; verified = false; paint(); }
    const promise = nativeFetch(input, init);
    if (mutation) promise.then(() => { external--; schedule(); }, () => { external--; schedule(); });
    return promise;
  };
  document.addEventListener('click', event => {
    const tile = event.target.closest('.jk-kafel');
    if (tile) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (!busy && !tile.disabled) enqueue(() => select(tile.dataset.jkWybor, tile.dataset.jgVariant || tile.dataset.jkWartosc)).catch(error);
      return;
    }
    const link = event.target.closest('a[href]');
    if (link && /\/(checkout|checkouts)(\/|\?|$)/.test(new URL(link.href, location.href).pathname) && (checkingOut || needsCheckoutCorrection())) {
      event.preventDefault(); event.stopImmediatePropagation(); checkout();
    }
  }, true);
  const approvedForms = new WeakSet();
  async function proceed(form, submitter, snapshot) {
    if (form && form.isConnected) {
      if (snapshot) {
        // Repaired/removed gift keys must not be submitted with stale quantities.
        form.querySelectorAll('input[name^="updates["]').forEach(input => {
          const key = input.name.slice(8, -1);
          const item = snapshot.cart.items.find(item => item.key === key);
          if (item) input.value = item.quantity;
          else input.disabled = true;
        });
      }
      await new Promise(resolve => setTimeout(resolve, 0));
      approvedForms.add(form);
      try { form.requestSubmit(submitter); }
      finally { approvedForms.delete(form); }
    } else location.assign(root + 'checkout');
  }
  function checkout(form, submitter) {
    if (checkingOut) return;
    checkingOut = true;
    enqueue(async () => {
      if (external) throw new Error('Cart update pending');
      const r = await reconcile();
      if (external) throw new Error('Cart update pending');
      // Only gift-only carts are stopped. Ordinary free products are purchases too.
      if (!r.s.cart.items.length || (r.s.cart.items.some(marked) && !r.p.paidCount)) {
        location.assign(root + 'cart'); return;
      }
      paint();
      await proceed(form, submitter, r.s);
    }).catch(async () => {
      error();
      await proceed(form, submitter); // Read already retried once; never trap the shopper.
    }).finally(() => { checkingOut = false; });
  }
  document.addEventListener('submit', event => {
    if (event.submitter?.name !== 'checkout') return;
    if (approvedForms.has(event.target)) return;
    if (!checkingOut && !needsCheckoutCorrection()) return;
    event.preventDefault(); event.stopImmediatePropagation(); checkout(event.target, event.submitter);
  }, true);
  document.addEventListener('input', event => { if (event.target.form) approvedForms.delete(event.target.form); }, true);
  new MutationObserver(records => {
    if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 &&
        (n.matches('.jk-kafel,[data-jk-cfg],[name=checkout]') || n.querySelector('.jk-kafel,[data-jk-cfg],[name=checkout]'))))) paint();
  }).observe(document.body, { childList: true, subtree: true });
  addEventListener('pageshow', schedule);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
  schedule();
})();
